import { render } from "./ScrollEnd.vue?vue&type=template&id=4bc013e0"
import script from "./ScrollEnd.vue?vue&type=script&lang=js"
export * from "./ScrollEnd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__